import { default as viewStateStore } from 'owa-mail-folder-store/lib/store/store';
import { action } from 'satcheljs/lib/legacy';
/*
 * Sets folder node view state
 * @param folderId the folder whose view state we are updating
 * @param folderViewState the view state to set
*/
export default action('setFolderViewState')(function setFolderViewState(folderId, folderViewState) {
    viewStateStore.folderNodeViewStates.set(folderId, folderViewState);
});
//# sourceMappingURL=setFolderViewState.js.map